var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1582:1599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8005 12.5995C25.8019 12.3978 25.6985 12.21 25.5279 12.1045H25.5249L25.5142 12.0985L16.6435 6.80652C16.6052 6.78044 16.5654 6.7566 16.5244 6.73513C16.1819 6.55704 15.775 6.55704 15.4325 6.73513C15.3915 6.75661 15.3518 6.78044 15.3134 6.80652L6.44278 12.0985L6.43207 12.1045C6.16095 12.2744 6.07784 12.6337 6.24643 12.9069C6.29611 12.9874 6.36453 13.0545 6.44576 13.1023L15.3165 18.3943C15.3549 18.4202 15.3946 18.444 15.4355 18.4657C15.778 18.6438 16.1849 18.6438 16.5274 18.4657C16.5683 18.444 16.608 18.4202 16.6465 18.3943L25.5172 13.1023C25.6944 12.9982 25.8026 12.8063 25.8005 12.5995Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47621 9.0666H13.2975V14.4444H7.47621V9.0666ZM24.6091 3.6V1.13999C24.6231 0.524937 24.1401 0.0147381 23.5298 0H8.42342C7.81313 0.0147381 7.33007 0.524937 7.34405 1.13999V3.6L16.2743 5.99999L24.6091 3.6Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34473 3.60156H13.2982V9.00156H7.34473V3.60156Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2514 3.60156H13.2979V9.00156L19.2514 14.4016H24.6095V9.00156L19.2514 3.60156Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2979 9H19.2513V14.4H13.2979V9Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2979 14.3984H19.2513V19.7984H13.2979V14.3984Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47656 14.4453H13.2979V19.3341H7.47656V14.4453Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.251 14.3984H24.6091V19.7984H19.251V14.3984Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5271 13.0714L25.5158 13.0774L16.6451 18.1054C16.6064 18.1293 16.5672 18.1521 16.5261 18.1725C16.3754 18.2449 16.2118 18.2857 16.045 18.2926L15.5604 18.0069C15.5195 17.9862 15.4797 17.9632 15.4413 17.9379L6.45159 12.7672H6.44742L6.15332 12.6016V22.7799C6.15791 23.459 6.7077 24.0059 7.38152 24.0015H24.5907C24.6008 24.0015 24.6097 23.9967 24.6204 23.9967C24.7627 23.9876 24.9031 23.9581 25.0372 23.9091C25.0951 23.8844 25.151 23.8551 25.2045 23.8215C25.2443 23.7988 25.3128 23.749 25.3128 23.749C25.6178 23.5215 25.7983 23.1623 25.7998 22.78V12.6016C25.7996 12.7962 25.6954 12.9758 25.5271 13.0714Z",
    fill: "url(#paint0_linear_1582:1599)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.3242 12.5594V13.1835L16.0486 19.6196L6.44566 12.7694C6.44566 12.7661 6.44299 12.7634 6.4397 12.7634L5.55859 12.2294V11.7794L5.92176 11.7734L6.68975 12.2174L6.7076 12.2234L6.77309 12.2654C6.77309 12.2654 15.7986 17.4554 15.8224 17.4674L16.1677 17.6714C16.1975 17.6594 16.2272 17.6474 16.2629 17.6354C16.2808 17.6234 25.2229 12.5534 25.2229 12.5534L25.3242 12.5594Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5271 13.0714L25.5158 13.078L16.6451 18.106C16.6064 18.1299 16.5671 18.1527 16.5261 18.1731C16.1816 18.3428 15.7787 18.3428 15.4342 18.1731C15.3934 18.1528 15.3537 18.1304 15.3151 18.106L6.44444 13.078L6.43373 13.0714C6.26247 12.9778 6.1551 12.7979 6.15332 12.6016V22.78C6.15758 23.4589 6.70718 24.0058 7.38087 24.0016C7.38089 24.0016 7.3809 24.0016 7.38093 24.0016H24.5722C25.2459 24.0059 25.7955 23.459 25.7998 22.78C25.7998 22.78 25.7998 22.78 25.7998 22.78V12.6016C25.7996 12.7962 25.6954 12.9758 25.5271 13.0714Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.7745 18.0312L16.6417 18.1063C16.6032 18.1309 16.5635 18.1536 16.5226 18.1741C16.3764 18.2464 16.2173 18.2888 16.0547 18.2988L19.4297 22.3212L25.3171 23.751C25.4785 23.6282 25.6068 23.4667 25.6904 23.2812L16.7745 18.0312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M17.3758 17.6875L16.6417 18.1033C16.6032 18.128 16.5635 18.1506 16.5226 18.1711C16.3764 18.2434 16.2173 18.2859 16.0547 18.2959L17.6359 22.6897L25.3189 23.7463C25.6216 23.5173 25.7998 23.1581 25.7999 22.7767V22.6453L17.3758 17.6875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3976 24.0015H24.5704C24.8347 24.0029 25.0924 23.9188 25.3057 23.7615L15.5598 18.0082C15.5189 17.9875 15.4791 17.9644 15.4407 17.9392L6.45099 12.7684H6.44682L6.15332 12.6016V22.7452C6.15265 23.4384 6.70973 24.0009 7.3976 24.0015C7.39758 24.0015 7.39758 24.0015 7.3976 24.0015Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.4882 5.90058V18.6986C14.4871 19.1473 14.2164 19.5506 13.8035 19.7186C13.6756 19.774 13.5379 19.8026 13.3987 19.8026H6.15332V5.40078H7.34402V4.80078H13.3987C14.0002 4.80308 14.4869 5.29442 14.4882 5.90058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.8929 6.49828V19.2963C13.8944 19.4412 13.8639 19.5847 13.8036 19.7163C13.6382 20.127 13.2432 20.3964 12.8034 20.3985H6.15332V5.39849H12.8034C12.9761 5.39674 13.1464 5.44017 13.2975 5.5245C13.6625 5.70979 13.8927 6.08645 13.8929 6.49828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.8929 6.49828V18.0963C13.8899 18.7021 13.4045 19.1932 12.8034 19.1985H6.15332V5.39849H12.8034C12.9761 5.39674 13.1464 5.44017 13.2975 5.52449C13.6625 5.70979 13.8927 6.08645 13.8929 6.49828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.2975 6.49823V18.0962C13.2969 18.703 12.8101 19.1954 12.208 19.1984H6.15332V5.39844H12.208C12.81 5.39876 13.2978 5.8909 13.2975 6.49764C13.2975 6.49784 13.2975 6.49804 13.2975 6.49823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29147 5.39844H12.2066C12.8093 5.39844 13.2979 5.89084 13.2979 6.49823V17.4986C13.2979 18.106 12.8093 18.5984 12.2066 18.5984H1.29147C0.688768 18.5984 0.200195 18.106 0.200195 17.4986V6.49823C0.200195 5.89084 0.688782 5.39844 1.29147 5.39844Z",
    fill: "url(#paint1_linear_1582:1599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61052 10.0109C3.87949 9.43334 4.31362 8.95004 4.85719 8.62307C5.45916 8.27574 6.14455 8.10258 6.83792 8.12266C7.48054 8.10861 8.11466 8.27279 8.67099 8.59726C9.19407 8.91163 9.61535 9.37226 9.88372 9.92325C10.176 10.5304 10.3216 11.1986 10.3088 11.8733C10.323 12.5784 10.1731 13.277 9.87122 13.9132C9.59647 14.4839 9.16182 14.961 8.62098 15.2854C8.0432 15.6199 7.38554 15.7883 6.71944 15.7727C6.06309 15.7886 5.415 15.6226 4.84588 15.2926C4.31827 14.9779 3.8917 14.5167 3.61708 13.9642C3.32309 13.3659 3.17571 12.7052 3.18724 12.0376C3.17499 11.3385 3.31969 10.6457 3.61052 10.0109ZM4.93934 13.2689C5.08274 13.634 5.32592 13.9506 5.64066 14.1821C5.96124 14.4079 6.34511 14.5244 6.7361 14.5145C7.15249 14.5311 7.56292 14.4106 7.90536 14.1713C8.21612 13.9405 8.45291 13.623 8.58644 13.258C8.73571 12.8505 8.80938 12.4187 8.80374 11.9843C8.80836 11.5457 8.73911 11.1095 8.59894 10.6943C8.47514 10.3194 8.24598 9.98879 7.9393 9.74266C7.60543 9.492 7.19611 9.36487 6.78015 9.38266C6.38069 9.37223 5.98822 9.48965 5.65911 9.71806C5.33905 9.95049 5.09126 10.2699 4.9447 10.6391C4.61957 11.4851 4.61788 12.4228 4.93993 13.2701L4.93934 13.2689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.251 3.60156H24.6091V9.00156H19.251V3.60156Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1582:1599",
    x1: 15.9766,
    y1: 12.6016,
    x2: 15.9766,
    y2: 24.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1582:1599",
    x1: 2.47552,
    y1: 4.53908,
    x2: 11.1227,
    y2: 19.3995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1582:1599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    fill: "white",
    transform: "translate(0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.51e5a1553b4448e16905599acbce95da.svg";
export { ForwardRef as ReactComponent };